module.exports = __webpack_public_path__ + "img/ss1 copy.0276f31b.png";